// Owner-only gate, same mechanism as config/notesAccess.js: an explicit UPN
// allowlist checked against account.username, lowercased.
//
// Contacts is owner-only because the directory holds 1,461 people's phone
// numbers, email addresses, birthdays and free-text notes — the most sensitive
// data in the platform, and the only module whose contents are about people who
// never consented to being in it.
//
// The list is SEPARATE from NOTES_ACCESS_ALLOWLIST even though it currently
// holds the same two accounts. Aliasing them would mean that granting someone
// Notes access silently granted them the whole contact directory too; these are
// different decisions and should stay independently changeable.
export const OWNER_ALLOWLIST = [
  'marc@defineholy.com',
  'marc@myfiginsurance.com',
];

export function userIsOwner(account) {
  if (!account || !account.username) return false;
  return OWNER_ALLOWLIST.includes(account.username.toLowerCase());
}

// Read-only viewers of the Contacts directory: they can open the page, list,
// search and view cards. Every write control (Edit, Delete, the primary star,
// + New, + Phone/Email, photo controls, the sync pill's retry/resolve taps) is
// hidden for them, so no write path is reachable from the UI. The relay's own
// allowlist (CONTACTS_SYNC_ALLOWED_USERS) is a separate, server-side gate.
// Kept separate from OWNER_ALLOWLIST for the same reason Notes is: granting
// someone a look at the directory must never silently grant edit.
export const VIEWER_ALLOWLIST = [
  'angela@defineholy.com',
];

export function userIsViewer(account) {
  if (!account || !account.username) return false;
  return VIEWER_ALLOWLIST.includes(account.username.toLowerCase());
}

/** Owners and viewers can open Contacts; only owners can change it (userIsOwner). */
export function userCanViewContacts(account) {
  return userIsOwner(account) || userIsViewer(account);
}
